export enum DashboardType {
	DASHBOARD = 'dashboard',
	FOLDER = 'folder',
	BOOK = 'dashboardSet',
	FEEDBACK_FOLDER = 'feedbackFolder'
}

